import { LocalService } from './../storage/localService';
import { SessionStorageService } from './../storage/sessionStorage.service';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, filter, pluck } from "rxjs/operators";
import { DocumentoNegociable } from "../../models/DocumentoNegociable";
import { NgxXml2jsonService } from "ngx-xml2json";
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { FiltrosDocumentosNegociables } from '../../models/FiltrosDocumentosNegociables';
import { FiltrosInversionistas } from "app/models/FiltrosInversionistas";
import { FiltrosFondo } from "app/models/FiltrosFondo";
import { FiltrosDnSubasta } from "../../models/FiltrosDnSubasta";
import { FiltrosDnxSubastar } from "../../models/FiltrosDnxSubastar";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class DocumentoNegociableService {

  message: Observable<any>;

  datosxsubastar: any;
  tipoAdjunto: number;
  tipoEmision: string;
  dataNegociable: any;
  dataNegociables: any;
  arrayFondo: any;
  xml2: JSON;
  datos: any = [];
  readonly urlBase = environment.rutaBase;
  idEmpresa_Factor: any;
  header: HttpHeaders;
  constructor(
    private http: HttpClient,
    private ngxXml2jsonService: NgxXml2jsonService,
    private accesoService: AccesoService,
    private sessionStorageService: SessionStorageService,
    private localService: LocalService
  ) {
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage()
  }

  datoStorage() {
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
    this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
    if (this.idEmpresa_Factor == undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
    }
  }

  obtenerDocNegociables() {
    let headers = this.header
    return this.http
      .get(
        `${this.urlBase}/comprobante?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=100000`, { headers }
      )
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  obtenerDocNegociablesById(idComprobante: any) {
    let headers = this.header
    return this.http
      .get(
        `${this.urlBase}/comprobante/${idComprobante}?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers }
      )
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }

  FiltrarDatosListadoDocNegociables(Filtros: FiltrosDocumentosNegociables) {


    let headers = this.header
    return this.http
      .get(
        `${this.urlBase}/comprobante?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=100000&NumeroCp=${Filtros.Numero}&ExisteAdjunto=${Filtros.Adjunto}&Tipo_Emision=${Filtros.Tipo_Emision}&Tipo_Comprobante=${Filtros.Tipo_Comprobante}&idProveedor=${Filtros.Id}&Estado=${Filtros.Estado}&User=${Filtros.user_id}`, { headers }
      )
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }


  validarEmpresaExistente(ruc: string, serie?: string) {

    let headers = this.header;
    if (serie) {

      return this.http
        .get(`${this.urlBase}/empresas/p?Ruc=${ruc}&Serie=${serie}&idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
        .pipe(
          map(data => {
            return data[0];
          })
        );
    } else {
      return this.http
        .get(`${this.urlBase}/empresas/p?idEmpresa_Factor=${this.idEmpresa_Factor}&Ruc=${ruc}`, { headers })
        .pipe(
          map(data => {
            return data[0];
          })
        );

    }


  }

  validarEmpresaExistenteADQ(ruc: string) {

    let headers = this.header;

    return this.http
      .get(`${this.urlBase}/empresas/a?Ruc=${ruc}&idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
      .pipe(
        map(data => {
          return data[0];
        })
      );
  }

  crearDocNegociable(data: DocumentoNegociable) {
    let headers = this.header;

    return this.http.post(
      `${this.urlBase}/comprobante?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers });
  }
  CambiarEstadoComprobante(data: DocumentoNegociable, idComprobante?: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/EstadoComprobante?idEmpresa_Factor=${this.idEmpresa_Factor}&idComprobante=${idComprobante}`, data, { headers });
  }

  actualizarDocNegociable(data: DocumentoNegociable, idComprobante?: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/comprobante/${idComprobante}?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers });
  }

  crearCuotas(body: any, idComprobante?: number) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/comprobante/cuota/${idComprobante}?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }

  toXml(url: any): JSON {
    let xml2 = url;
    let newURL = url.substring(url.indexOf("<Invoice"), url.indexOf("</Invoice") + 10);

    let newyrl6 = this.clearXML(xml2);
    let newyrl7 = this.clearXML(newURL);

    const parser = new DOMParser();

    const xml = parser.parseFromString(newyrl6, "text/xml");
    const obj = this.ngxXml2jsonService.xmlToJson(xml);

    const xml3 = parser.parseFromString(newyrl7, "text/xml");
    const obj2 = this.ngxXml2jsonService.xmlToJson(xml3);

    this.xml2 = obj["AttachedDocument"];
    this.xml2["invoice"] = obj2;

    return this.xml2;
  }

  clearXML(url: any) {
    let xml2 = url;

    let CDATA = /\<\!\[CDATA\[/gi;
    let newyrl = xml2.replace(CDATA, "");

    let CORCHETE = /\]\]\>/gi;
    let newurl2 = newyrl.replace(CORCHETE, "");

    let AMPERSAND = /&/gi;
    let newyrl3 = newurl2.replace(AMPERSAND, "&amp;");

    let CAC = /cac:/gi;
    let newyrl4 = newyrl3.replace(CAC, "");

    let CBC = /cbc:/gi;
    let newyrl5 = newyrl4.replace(CBC, "");


    CBC = /sts:/gi;
    newyrl5 = newyrl5.replace(CBC, "");
    CBC = /ds:/gi;
    newyrl5 = newyrl5.replace(CBC, "");
    CBC = /xades:/gi;
    newyrl5 = newyrl5.replace(CBC, "");
    CBC = /ext:/gi;
    newyrl5 = newyrl5.replace(CBC, "");


    let BR = /\<BR\>/gi;
    let newyrl6 = newyrl5.replace(BR, "");



    return newyrl6;
  }
  guardarArchivoGDrive(body: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/comprobante/adjunto?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers })
  }

  ObtenerFacturasFondoInversion(Filtros: FiltrosInversionistas) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', 'cd2nRttcAGmIiw4WeK5MUUnbowoabW');
    return this.http.get(`${this.urlBase}/fondo?idEmpresa_Factor=${this.idEmpresa_Factor}&idProveedor=${Filtros.IdProv}&idAdquirente=${Filtros.IdAdq}&Moneda=${Filtros.Moneda}&FechaDesde=${Filtros.FechaIni}&FechaHasta=${Filtros.FechaFin}`, { headers });
  }

  ListarDocumentosNICLV(Filtros: FiltrosFondo) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', 'cd2nRttcAGmIiw4WeK5MUUnbowoabW');
    return this.http.get(`${this.urlBase}/dniclvGet?idEmpresa_Factor=${this.idEmpresa_Factor}&Participante=${Filtros.Parti}&CodigoValor=${Filtros.Cod}&Estado=${Filtros.Estado}&FechaDesde=${Filtros.FechaIni}&FechaHasta=${Filtros.FechaFin}`, { headers });
  }

  CrearFondo(body: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/dniclv?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }

  obtenerDocumentosSubasta(Filtros: FiltrosDnSubasta) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/dnSubasta?idEmpresa_Factor=${this.idEmpresa_Factor}&idAdquirente=${Filtros.IdAdq}&Moneda=${Filtros.Moneda}&FechaDesde=${Filtros.FechaIni}&FechaHasta=${Filtros.FechaFin}`, { headers });
  }

  obtenerDocumentosxSubastar(Filtros: FiltrosDnxSubastar) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/dnxSubastar?idEmpresa_Factor=${this.idEmpresa_Factor}&Estado=${Filtros.Estado}`, { headers });
  }

  ObtenerDnSubasta(body: any) {

    let headers = this.header;
    return this.http.get(`${this.urlBase}/ObtenerDnSubasta?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=100000&Tipo_Comprobante=${body.Tipo_Comprobante}&idComprobante=${body.idComprobante}&Num_Doc_Identificacion_Prov=${body.Num_Doc_IdentificacionProv}&Num_Doc_Identificacion_ADQ=${body.Num_Doc_IdentificacionADQ}&Moneda=${body.Moneda}&Estado=${body.Estado}`, { headers });
  }

  CrearDnSubasta(body: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/crearSubasta?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }
  cargaMasiva(body: any, tipo: any) {
    let headers = this.header;

    return this.http.post(`${this.urlBase}/comprobante/carga-masiva/${tipo}?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers })
      .pipe(
        map((data) => {
          return data;
        }))
  }
}